import { Tooltip } from 'seagull';
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import { accountingIconMap } from "../../../integrations/Accounting/AccountingIcon/accountingIconMap";
import { formatDateTimeWithShortMonth } from "../../../utils/date-formatting";
import { jsx as _jsx } from "react/jsx-runtime";
const accountingName = accountingType => getAccountingDetails(accountingType).fullName;
export function getTooltip(integration, accountingType) {
  return integration.accept({
    whenSynced: _ref => {
      let {
        date
      } = _ref;
      return "Payout recorded in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    },
    whenSyncFailed: () => "Payout sync failed in ".concat(accountingName(accountingType)),
    whenPendingSync: data => data.invoicesReady ? "Pending payout sync to ".concat(accountingName(accountingType)) : "Pending sync to ".concat(accountingName(accountingType)),
    whenSyncInProgress: () => "Payout sync in progress in ".concat(accountingName(accountingType)),
    whenDeleted: _ref2 => {
      let {
        date
      } = _ref2;
      return "Payout deleted in ".concat(accountingName(accountingType), " on ").concat(formatDateTimeWithShortMonth(new Date(date)));
    }
  });
}
function getIconStatus(integration) {
  return integration.accept({
    whenSynced: () => 'success',
    whenSyncFailed: () => 'error',
    whenPendingSync: () => 'pending',
    whenSyncInProgress: () => 'syncing',
    whenDeleted: () => 'success'
  });
}
export function PayoutAccountingIntegrationStatus(props) {
  const {
    testid,
    integration,
    accounting
  } = props;
  return integration ? /*#__PURE__*/_jsx("div", {
    "data-testid": testid,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testid, "-tooltip"),
        children: getTooltip(integration, accounting)
      }),
      placement: "top",
      "data-testid": "".concat(testid, "-tooltip"),
      children: /*#__PURE__*/_jsx("span", {
        style: {
          display: 'inline-block'
        },
        children: accountingIconMap[accounting][getIconStatus(integration)]
      })
    })
  }) : null;
}